<template>
  <div class="row">
    <div class="col-2"></div>
    <div class="col-8">
      <div class="d-flex justify-content-start">
        <div>
          <font-awesome-icon :icon="['fas', 'circle']" />
        </div>
        <div>修改密碼</div>
      </div>
      <hr />
      <div class="card text-center">
        <div class="card-header">
          <div class="row text-left">
            <div class="col-12">按下確認修改後，將立即更新您的密碼。</div>
            <div class="passwdRule col-12">(密碼長度為6-15碼英文或數字組合，不可包含特殊字元，例如：@#,-...等)</div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <div class="row text-left">
                <div class="col-4">會員帳號</div>
                <div class="col-8">123</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row text-left">
                <div class="col-4">會員姓名</div>
                <div class="col-8">123</div>
              </div>
            </div>
          </div>
          <div class="form-group row mt-4">
            <label for="inputOldPassword" class="col-2 text-left col-form-label">原密碼</label>
            <div class="col-10">
              <input type="password" class="form-control" id="inputOldPassword" />
            </div>
          </div>
          <div class="form-group row">
            <label for="inputNewPassword" class="col-2 text-left col-form-label">新密碼</label>
            <div class="col-10 text-left">
              <input type="password" class="form-control" id="inputNewPassword" />
              <small>請輸入6-15位英數字混合密碼，英文需區分大小寫</small>
            </div>
          </div>
          <div class="form-group row">
            <label for="inputNew2Password" class="col-2 text-left col-form-label">在確認密碼</label>
            <div class="col-10">
              <input type="password" class="form-control" id="inputNew2Password" />
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button type="button" class="btn btn-primary">確認修改</button>
        </div>
      </div>
    </div>
    <div class="col-2"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.passwdRule {
  color: #dc3545 !important;
}
</style>
